import { render, staticRenderFns } from "./group-posts-list.vue?vue&type=template&id=55764fa5"
import script from "./group-posts-list.vue?vue&type=script&lang=js"
export * from "./group-posts-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports